module.exports = __webpack_public_path__ + "static/media/sonomo.e0980e74.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/sonomo.webp
// module id = 884
// module chunks = 0